<div #trigger class="inline-block">
  @if (totalNaoLidas > 0) {
    <app-overlay-badge
      [value]="totalNaoLidas > 99 ? '99+' : totalNaoLidas"
      [severity]="'danger'"
      [badgeSize]="'small'"
    >
      <app-icon-button
        [icon]="'bell'"
        [variant]="'text'"
        [severity]="'secondary'"
        [textColor]="'white'"
        [styleClass]="'notificacao-icon-button'"
        (handleClick)="togglePanel($event)"
        [attr.aria-label]="totalNaoLidas + ' notificações não lidas'"
        aria-haspopup="true"
        [attr.aria-expanded]="notifPanel?.overlayVisible"
      />
    </app-overlay-badge>
  } @else {
    <app-icon-button
      [icon]="'bell'"
      [variant]="'text'"
      [severity]="'secondary'"
      [textColor]="'white'"
      [styleClass]="'notificacao-icon-button'"
      (handleClick)="togglePanel($event)"
      aria-label="Notificações"
      aria-haspopup="true"
      [attr.aria-expanded]="notifPanel?.overlayVisible"
    />
  }
</div>
<app-popover #notifPanel [style]="{ width: '380px' }">
  <div class="flex items-center justify-between pb-3 border-b border-gray-200">
    <div>
      <h3 class="text-base font-semibold text-gray-900">Notificações</h3>
      <span class="text-sm text-gray-500">{{ totalNaoLidas }} não lidas</span>
    </div>
    <app-button
      *ngIf="totalNaoLidas > 0"
      [label]="'Marcar todas como lidas'"
      [variant]="'text'"
      [size]="'small'"
      [styleClass]="
        'text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline px-2 py-1'
      "
      [actionType]="'button'"
      (handleClick)="marcarTodasComoLidas()"
      aria-label="Marcar todas as notificações como lidas"
    ></app-button>
  </div>

  <div *ngIf="carregando" class="py-8 text-center">
    <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
    <p class="mt-2 text-sm text-gray-500">Carregando...</p>
  </div>

  <div
    *ngIf="!carregando && notificacoes.length > 0"
    class="mt-3 overflow-y-auto max-h-80 notificacoes-scroll"
    #scrollContainer
  >
    @for (notificacao of notificacoes; track notificacao.id) {
      <button
        type="button"
        (click)="marcarComoLida(notificacao)"
        class="w-full text-left p-3 mb-1 cursor-pointer transition-colors hover:bg-gray-50 focus:outline-none focus:bg-gray-50 focus:ring-2 focus:ring-inset focus:ring-blue-500 rounded-md border-0 bg-transparent"
        [class.hover:bg-blue-100]="!notificacao.lida"
        [attr.aria-label]="'Notificação: ' + notificacao.titulo"
      >
        <span class="flex items-start gap-3">
          <span class="flex-shrink-0 -mt-1">
            <span
              class="inline-block w-2.5 h-2.5 rounded-full"
              [ngClass]="obterCorIndicador(notificacao)"
              aria-hidden="true"
            ></span>
          </span>

          <span class="flex-1 min-w-0">
            <span class="block text-sm font-semibold text-gray-900">
              {{ notificacao.titulo }}
            </span>
            <span class="block mt-1 text-sm text-gray-600 leading-relaxed">
              {{ notificacao.conteudo }}
            </span>
            <span class="block mt-2 text-xs text-gray-400">
              {{ formatarData(notificacao.createdAt) }}
            </span>
          </span>

          <span class="flex-shrink-0 mt-1.5">
            <span
              *ngIf="!notificacao.lida"
              class="inline-block w-2 h-2 bg-blue-500 rounded-full"
              aria-label="Não lida"
            ></span>
          </span>
        </span>
      </button>
    }

    <div class="w-full">
      <app-button
        *ngIf="btnCarregarMais"
        (handleClick)="carregarMaisNotificacoes()"
        label="Carregar mais"
        size="small"
        variant="outlined"
        [styleClass]="'w-full'"
      >
      </app-button>
    </div>
  </div>

  <div
    *ngIf="!carregando && notificacoes.length === 0"
    class="py-8 text-center"
  >
    <i class="pi pi-bell text-4xl text-gray-300"></i>
    <p class="mt-3 text-sm text-gray-500">
      Não há itens de notificação para exibição
    </p>
  </div>

  <div
    *ngIf="!pushHabilitado && !carregando"
    class="pt-3 mt-3 border-t border-gray-200"
  >
    <div
      class="flex items-center justify-between p-3 bg-yellow-50 rounded-lg border border-yellow-200"
    >
      <div class="flex items-center gap-2">
        <i class="pi pi-bell text-yellow-600"></i>
        <span class="text-xs font-medium text-gray-700"
          >Notificações push desativadas</span
        >
      </div>
      @if (!pushHabilitado) {
        <app-button
          [label]="'Ativar'"
          [variant]="'text'"
          [size]="'small'"
          [styleClass]="
            'text-xs font-medium text-blue-600 hover:text-blue-800 px-2 py-1'
          "
          [actionType]="'button'"
          (handleClick)="habilitarNotificacoes()"
          aria-label="Ativar notificações push"
        ></app-button>
      }
    </div>
  </div>
</app-popover>
